import React from 'react';
import styles from './Billboard.module.css';
import BasePanel from '../BasePanel/BasePanel.jsx';

const billboardImg = require('../../../../images/Illustration_Play_Billboard.png');
const billboardCanNotLoadImg = require('../../../../images/billboard_can_not_load_adcopy.png');

const Billboard = ({ mediaArray, videoAutoPlayInterval }) => {

    return (
        <BasePanel
            mediaArray={mediaArray}
            backgroundImage={billboardImg}
            cannotLoadImage={billboardCanNotLoadImg}
            customStyles={styles}
            videoAutoPlayInterval={videoAutoPlayInterval}
        />
    );
};

export default Billboard;